module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-3.e69dbf39.jpg";